import React, {useState} from 'react';
import {Form, Input, Modal, Select, Upload} from 'antd';

const {Option} = Select;

function ActiveFormModal({visible, onCreate, onCancel}) {
    const [form] = Form.useForm();
    const [httpHead, setHttpHead] = useState('https://');

    const selectBefore = (
        <Select value={httpHead} className="select-before" onChange={changeHttpHead}>
            <Option value="http://">http://</Option>
            <Option value="https://">https://</Option>
        </Select>
    );

    function changeHttpHead(e) {
        setHttpHead(e);
    }

    return (
        <Modal
            visible={visible}
            title="新增链接"
            okText="确定"
            cancelText="取消"
            onCancel={onCancel}
            onOk={() => {
                form.validateFields()
                    .then(values => {
                        form.resetFields();
                        values.url = httpHead + values.url;
                        onCreate(values);
                    })
                    .catch(info => {
                        console.log('Validate Failed:', info);
                    });
            }}
        >
            <Form form={form} layout="vertical" name="form_in_modal">
                <Form.Item
                    label="标题"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: '标题不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="链接"
                    name="url"
                    rules={[
                        {
                            required: true,
                            message: '链接不能为空!',
                        },
                    ]}
                >
                    <Input addonBefore={selectBefore} />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default ActiveFormModal;
